import { GqlSettingsFormTemplateMasterFormType } from "~/__generated__";

const masterFormTypeMap: Record<string, GqlSettingsFormTemplateMasterFormType> = {
    preciseLocation: GqlSettingsFormTemplateMasterFormType.PreciseLocation,
    startVisit: GqlSettingsFormTemplateMasterFormType.StartVisit,
};

export function toMasterFormType(param: string): GqlSettingsFormTemplateMasterFormType {
    const type = masterFormTypeMap[param];
    if (!type) throw new Error("Invalid masterFormTyep param");
    return type;
}
